import ReactDOM from 'react-dom/client';
import 'globalthis/polyfill';
import 'globalthis/auto';
import 'babel-polyfill';
import './utils/polyfill-queue-microtask';
import './assets/styles/swiper.min.css';
import './assets/styles/theme/theme.css';
import './assets/styles/font.css';
import './assets/styles/global.css';
import './index.css';
import './utils/sentry';
import App from './app';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
